import { render, staticRenderFns } from "./MagazineList.vue?vue&type=template&id=48e0a9d4&scoped=true&"
import script from "./MagazineList.vue?vue&type=script&lang=js&"
export * from "./MagazineList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e0a9d4",
  null
  
)

export default component.exports